import { render, staticRenderFns } from "./statewide-main.vue?vue&type=template&id=2ac51256&scoped=true"
import script from "./statewide-main.vue?vue&type=script&lang=js"
export * from "./statewide-main.vue?vue&type=script&lang=js"
import style0 from "./statewide-main.vue?vue&type=style&index=0&id=2ac51256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac51256",
  null
  
)

export default component.exports